import React from 'react'
import { Link } from 'react-router-dom';
import { GrCertificate} from "react-icons/gr";
import { GiTakeMyMoney} from "react-icons/gi";
import { FaPeopleArrows} from "react-icons/fa";
import { GiLetterBomb } from "react-icons/gi";
const benefits = [
  { icon: <GiLetterBomb size="40px" color="black" />, text: 'Campus Amb.letter' },
  { icon: <GrCertificate size="40px" color="black" />, text: 'Ambassador Certificate' },
  { icon: <FaPeopleArrows size="40px" color="black" />, text: 'Marketing Internship' },
  { icon: <GiTakeMyMoney size="40px" color="black" />, text: 'Incentive Upto 5K' }
];

const benefitsDesktop = [
  { icon: <GiLetterBomb size="50px" color="black" />, text: 'Campus Ambassador letter' },
  { icon: <GrCertificate size="50px" color="black" />, text: 'Ambassador Certificate' },
  { icon: <FaPeopleArrows size="50px" color="black" />, text: 'Internship Opportunity' },
  { icon: <GiTakeMyMoney size="50px" color="black" />, text: 'Incentive Upto 5K' }
];
function Campus_Ambassador_discuraption() {
  return (
    <div>
      {/* ----------------Mobile View----------------*/}
      <div className='d-sm-block d-md-none'>
        <div className='pt-2 container'>
          <div className='text-center Mobile_CA_Discraption_text'>
            <h1 className='pb-1'>About Campus Ambassador</h1>
            <p className=''>Join us as a Campus Ambassador and be the catalyst for change, innovation, and connection on your campus!
              Feel free to customize it based on the specific goals and benefits of your Campus Ambassador program.</p>
            <h1 className=''>Benefits for Campus Ambassador</h1>
          </div>
        </div>
        <div className='py-4 container'>
          <div className='row px-2'>
            {benefits.map((benefit, index) => (
              <div className='col-6 pb-4 px-1' key={index}>
                <div className='shadow text-center Mobile_CA_border_icon py-4'>
                  {benefit.icon}
                  <p className='pt-2 mobile_CA_benefit_text'>{benefit.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ----------------Desktop View----------------     */}
      <div className='pt-4 d-none d-md-block'>
        <div className='container pb-5'>
              <div className='text-center container CA_Discraption_text'>
                <h1 className='display-5 py-2'>About Campus Ambassador</h1>
                <p className='px-5 mx-5'>Join us as a Campus Ambassador and be the catalyst for change, innovation, and connection on your campus! Feel free to customize it based on the specific goals and benefits of your Campus Ambassador program.</p>
                <h1 className='display-6'>Benefits for Campus Ambassador</h1>
              </div>
        </div>
        <div className='pb-5 container'>
          <div className='row'>
            {benefitsDesktop.map((benefit, index) => (
              <div className='col-md-3' key={index}>
                <div className='CA_card shadow text-center CA_border_icon py-4'>
                  {benefit.icon}
                  <p className='pt-4 CA_benefit_text'>{benefit.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Campus_Ambassador_discuraption
